// Governance queue: the routes and the sidebar rows of `wealth.intelligence.governance-queue` (ADR-0027).
import { defineWebFeature } from '@/features/kit';

export default defineWebFeature({
    id: 'wealth.intelligence.governance-queue',
    routes: [
        {
            frontend: 'view',
            path: 'governance-queue',
            lazy: () => import('@/pages/view/governance-queue/page'),
        },
    ],
});
